'use client'

import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
} from 'react'

const ZeroEuroCopaymentEligibilityContext = createContext<boolean | undefined>(
  undefined,
)

export const ZeroEuroCopaymentEligibilityProvider: FC<
  PropsWithChildren<{ value: boolean }>
> = ({ children, value }) => (
  <ZeroEuroCopaymentEligibilityContext.Provider value={value}>
    {children}
  </ZeroEuroCopaymentEligibilityContext.Provider>
)

export const useZeroEuroCopaymentEligibility = (): boolean => {
  const value = useContext(ZeroEuroCopaymentEligibilityContext)

  if (value === undefined) {
    throw new Error(
      'useZeroEuroCopaymentEligibility must be used within ZeroEuroCopaymentEligibilityProvider',
    )
  }

  return value
}
